<template>
  <div class="search-input">
    <input type="text" v-model="searchStr">
    <div class="btn" @click="clickSearch">
      {{lang === 'zh' ? '搜&nbsp;&nbsp;索' : 'Search'}}</div>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: ['onSearch'],
  data() {
    return {
      searchStr: ''
    }
  },
  computed: {
    lang() {
      return this.$store.state.mlang;
    }
  },
  methods: {
    clickSearch() {
      if(this.searchStr) {
        this.$router.push('/mobile/search?keywords=' + this.searchStr);
      }
    }
  }
}
</script>

<style lang="less">
@import "../../common/theme";
@se-size-1: calc(@mobileFont * .55);
.mobile-home {
  .search-input {
    display: flex;
    padding: 0 @se-size-1;
    margin-bottom: 40px;
    .btn {
      width: 80px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      background: #037698;
    }
    input {
      border: 1px solid #d2d2d2;
      border-radius: 0;
      width: calc(100% - 80px);
      outline: none;
      padding: 0 10px;
    }
  }
}
</style>
